import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UserStoreService } from 'src/app/services/user-store.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  language$: Observable<string>;
  user = '';
  email = '';
  showSearch = false;

  constructor(
    private route: ActivatedRoute,
    private oauthService: OAuthService,
    private userStore: UserStoreService
  ) {}

  ngOnInit(): void {
    this.language$ = this.route.paramMap.pipe(
      switchMap(params => {
        return params.get('language');
      })
    );
    this.userStore.user.subscribe((user) => {
      if (user.firstName != null || user.lastName != null) {
        this.user = user.firstName + " " + user.lastName;
      }
      this.email = user.email;
      this.showSearch = user.businessAdmin;
    });
  }

  logout() {
    this.oauthService.logOut();
  }
}
